export default __webpack_public_path__ + "static/pledge_socialimpact-a22a4a9565c8f5de00c5bf5b0d0952a9.webp";